import {
    useQuery,
} from '@tanstack/react-query'

import {
    getCategories,
} from 'api/fetch/category';

export const useQueryCategory = (fetchDataOptions: {
    offset: number,
    limit: number,
    search?: string,
    include?: number[],
}) => {
    const { data, error, isFetching, refetch } = useQuery(
        ['category', fetchDataOptions],
        () => getCategories(fetchDataOptions),
        {
            staleTime: 60 * 1000,
            cacheTime: 0,
            retry: false,
            keepPreviousData: true,
        }
    );

    return {
        data,
        refetch,
        error,
        isFetching,
    }
};